<p-fileupload #theFileUpload name="files[]" [customUpload]="true" [auto]="true" [multiple]="true"
  (onSelect)="onSelect()"
  [showCancelButton]="false" accept="application/pdf" [maxFileSize]="100000000" [disabled]="disableAddDrafts"
  (uploadHandler)="doUpload($event)" class="drafts-upload" i18n-chooseLabel="@@sidebar-add-document" chooseLabel="Add">

  <ng-template pTemplate="toolbar">
    <div class="sidebar-buttons-container">
      <button type="button" pButton icon="fa fa-solid fa-pencil" iconPos="right" [disabled]="selectedDocuments.length === 0"
        i18n-label="@@sidebar-update-selected" label="Edit selected" (click)="showUpdateMetadataDialog()"
        severity="secondary">
      </button>
      <button type="button" pButton icon="fa fa-regular fa-trash-can" iconPos="right" [disabled]="selectedDocuments.length === 0"
        i18n-label="@@sidebar-delete-selected" label="Delete selected" (click)="showDeleteMultipleConfirmation()"
        severity="danger" class="mt-2 delete-button">
      </button>
    </div>
  </ng-template>

  <ng-template let-file pTemplate="file">
    <div>{{ file }}</div>
  </ng-template>

  <ng-template pTemplate="content">
    @if (!disableAddDrafts) {
      <div class="text-align-center" style="height: 20px">
        <span i18n="@@sidebar-drag-drop-here">Drag and drop your files here</span>
      </div>
    } @else {
      <div class="text-align-center" style="height: 20px; color: red">
        <span i18n="@@sidebar-too-many-drafts">You cannot add more documents without validating or deleting existing drafts</span>
      </div>
    }
  </ng-template>

</p-fileupload>


<div style="display: none">
  <app-configure-filters uniqueKey="draftsList"></app-configure-filters>
</div>
@if (user && !user.anonymous) {
  <app-generic-list [tableReloadObservable]="tableReloadSubject.asObservable()" [onLazyLoad]="load" [api]="api"
    (dataChange)="draftsDataChanged($event)" [multiSortMeta]="[{field: 'filename', order: 1}]"
    [forceFilters]="forceFilters" [updateUrlOnLoad]="false" [showPaginator]="false"
    [checkboxSelection]="true" (selectedItemsChange)="selectDocuments($event)" selectionMode="multiple"
    styleClass="drafts-list" uniqueKey="draftsList">
    <app-generic-column key="filename" i18n-title="" title="" minWidth="30px" class="filename-column">
      <ng-template let-document>
        <button pButton (click)="onOpenDocument(document)" [label]="document.filename"
          class="document-button p-button-text"
          [ngClass]="{'p-button-current-doc': activeUuid === document.uuid}">
        </button>
      </ng-template>
    </app-generic-column>
    <app-generic-column key="id" [enableSort]="false" [filterType]="FilterType.NONE" minWidth="30px" class="id-column">
      <ng-template let-document>
        <button pButton icon="fa fa-regular fa-trash-can" label="" (click)="onDeleteSingleDocument(document)" class="p-button-text">
        </button>
      </ng-template>
    </app-generic-column>
  </app-generic-list>
}
